const DEFAULT_NEXT_PATH = "/profile";

export function sanitizeNextPath(
  value: string | null | undefined,
  fallback = DEFAULT_NEXT_PATH,
) {
  const candidate = value?.trim();
  if (!candidate) return fallback;
  if (!candidate.startsWith("/") || candidate.startsWith("//")) {
    return fallback;
  }
  if (candidate.includes("\\") || /[\u0000-\u001F\u007F]/.test(candidate)) {
    return fallback;
  }

  try {
    const parsed = new URL(candidate, "https://skylight.local");
    if (parsed.origin !== "https://skylight.local") return fallback;
  } catch {
    return fallback;
  }

  return candidate;
}

export function authHrefFor(next: string, context: string) {
  const params = new URLSearchParams({
    next: sanitizeNextPath(next),
    context,
  });
  return `/auth?${params.toString()}`;
}

export function profileSetupHrefFor(next: string) {
  const safeNext = sanitizeNextPath(next);
  if (safeNext === "/profile/setup" || safeNext.startsWith("/profile/setup?")) {
    return safeNext;
  }
  return `/profile/setup?next=${encodeURIComponent(safeNext)}`;
}
